export const IMPORT_REPORT_LIST_INITING = 'IMPORT_REPORT_LIST_INITING'
export const IMPORT_REPORT_LIST_REQUESTING = 'IMPORT_REPORT_LIST_REQUESTING'
export const IMPORT_REPORT_LIST_SUCCESS = 'IMPORT_REPORT_LIST_SUCCESS'
export const IMPORT_REPORT_LIST_ERROR = 'IMPORT_REPORT_LIST_ERROR'

export const IMPORT_REPORT_NCC_REQUESTING = 'IMPORT_REPORT_NCC_REQUESTING'
export const IMPORT_REPORT_NCC_SUCCESS = 'IMPORT_REPORT_NCC_SUCCESS'
export const IMPORT_REPORT_NCC_ERROR = 'IMPORT_REPORT_NCC_ERROR'

export const IMPORT_REPORT_KHO_REQUESTING = 'IMPORT_REPORT_KHO_REQUESTING'
export const IMPORT_REPORT_KHO_SUCCESS = 'IMPORT_REPORT_KHO_SUCCESS'
export const IMPORT_REPORT_KHO_ERROR = 'IMPORT_REPORT_KHO_ERROR'

export const IMPORT_EXPORT_XLS_INITING = 'IMPORT_EXPORT_XLS_INITING'
export const IMPORT_EXPORT_XLS_REQUESTING = 'IMPORT_EXPORT_XLS_REQUESTING'
export const IMPORT_EXPORT_XLS_SUCCESS = 'IMPORT_EXPORT_XLS_SUCCESS'
export const IMPORT_EXPORT_XLS_ERROR = 'IMPORT_EXPORT_XLS_ERROR'

export const IMPORT_REPORT_NCC_API = '/api/v1/management/nhacc_list_by_store'
export const IMPORT_REPORT_KHO_API = '/api/v1/management/kho_cap_list_by_store_user'
export const IMPORT_REPORT_LIST_API = '/api/v1/report/baoCaoNhapHang'
export const IMPORT_EXPORT_XLS_API = '/api/v1/report/bao_cao_nhap_hang_export_by_store' 


// WEBPACK FOOTER //
// ./src/views/Reports/ImportReport/constants.js